import Vue from 'vue'

export type EventBusCallback<T> = (arg: T) => void | Promise<void>

/**
 * EventBus super class
 * @export
 * @abstract
 * @class EventBus
 * @extends {Vue}
 * @author Roy Lee
 */
export default abstract class EventBus<T = any> extends Vue {
  abstract name(): string

  /**
   * emit eventbus data
   * @param {T} arg
   * @memberof EventBus
   */
  emit(arg: T) {
    this.$emit(this.name(), arg)
  }

  /**
   * promise로 emit 수행
   * @param arg
   */
  emitPromise(arg: T) {
    return new Promise<any>(resolve => {
      // @ts-ignore
      arg.callback = resolve
      this.$emit(this.name(), arg)
    })
  }

  /**
   * add listner eventbus
   * @param callback
   */
  on(callback: EventBusCallback<T>) {
    this.$on(this.name(), callback)
  }

  /**
   * add listner eventbus (once)
   * @param callback
   */
  once(callback: EventBusCallback<T>) {
    this.$once(this.name(), callback)
  }

  /**
   * remove listner eventbus
   * @param callback
   */
  off(callback?: EventBusCallback<T>) {
    this.$off(this.name(), callback)
  }
}
